'use strict';

var GridDateReoptPreviewButtonDirective = function GridDateReoptPreviewButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-date-reopt-preview-button.html'),
    controller: 'GridDateReoptPreviewButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows) {
        $scope.onRowSelection(event, selectedRows, gridId, allRows);
      });
    }
  };
};
GridDateReoptPreviewButtonDirective.$inject = [];
module.exports = GridDateReoptPreviewButtonDirective;